// A GSTIN — the 15-character GST identification number — validated by format and check character
// (spec/06 §10.3 rule 1). A venue's registration (F-PAY-11) and a sale's B2B buyer (F-CMP-07) both use it.
import { z } from "../zod.js";
/** Two-digit state code, five-letter and four-digit PAN body, PAN entity letter, entity code, `Z`, check char. */
export const GSTIN_PATTERN = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
const GSTIN_ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
/**
 * The GSTIN check character (its 15th), computed from the first 14 by the Luhn mod-36 algorithm the
 * GSTN uses. A `regular` or `composition` registration whose GSTIN's check character does not match is
 * a typo, refused before it can be recorded.
 */
export function gstinCheckCharacter(first14) {
    const modulus = GSTIN_ALPHABET.length; // 36
    let factor = 2;
    let sum = 0;
    for (let index = first14.length - 1; index >= 0; index -= 1) {
        const codePoint = GSTIN_ALPHABET.indexOf(first14[index]);
        let addend = factor * codePoint;
        factor = factor === 2 ? 1 : 2;
        addend = Math.floor(addend / modulus) + (addend % modulus);
        sum += addend;
    }
    return GSTIN_ALPHABET[(modulus - (sum % modulus)) % modulus];
}
/** Is `value` a well-formed GSTIN with a valid check character (spec/06 §10.3 rule 1)? */
export function isValidGstin(value) {
    return GSTIN_PATTERN.test(value) && gstinCheckCharacter(value.slice(0, 14)) === value[14];
}
export const GstinSchema = z
    .string()
    .refine(isValidGstin, 'Expected a 15-character GSTIN with a valid check character.')
    .openapi('Gstin', {
    description: 'A 15-character GST identification number (spec/06 §10.3). Required for a registered venue.',
    example: '29ABCDE1234F1ZW',
});
//# sourceMappingURL=gstin.js.map